import { render } from "./NervConsole.vue?vue&type=template&id=ed82ecfe&scoped=true&ts=true"
import script from "./NervConsole.vue?vue&type=script&lang=ts"
export * from "./NervConsole.vue?vue&type=script&lang=ts"

import "./NervConsole.vue?vue&type=style&index=0&id=ed82ecfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed82ecfe"]])

export default __exports__